import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-tooltip-content-base',
    templateUrl: './tooltip-content-base.component.html',
    styleUrls: ['./tooltip-content-base.component.scss'],
    standalone: false
})
export class TooltipContentBaseComponent implements OnInit {

  constructor() { }
  public data : any;
  
  ngOnInit(): void {
  }

}
